import {
  Grid,
  Typography,
  Card,
  CardContent,
  Divider,
  Chip,
  Avatar,
  Button,
  Dialog,
  MuiDialogActions,
  IconButton,
} from "@material-ui/core";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import { useDividerStyles } from "./styles";
import React, { useEffect } from "react";
import {
  PillDark,
  TaskIcon,
  Pills,
  DocumentBlack,
  Clock,
  Calender,
  Diagnosis,
  Speciality,
  LocationIcon,
  StethoscopeIcon,
} from "../../../../../assets";
import OrderDetailTable from "../../../../orderDetailTable";
import VerticalLinearStepper from "../remark";
import StatusLog from "../../../../statusLog";
import { actions } from "frequencyscreen_v_dbinder";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

const useStyles = makeStyles({
  align: {
    marginLeft: "30px",
    marginTop: "20px",
  },
  align2: {
    marginTop: "20px",
  },
  heading: {
    fontSize: "12px !important",

    marginLeft: "5px",
  },
  header: {
    fontSize: "14px !important",
    color: "#2A3C50",
    fontWeight: 600,
  },
  subContents: {
    fontSize: "14px !important",
    color: "#2A3C50",
    marginLeft: "18px",
  },
  secondline: {
    marginTop: "24px",
  },
  card: {
    minWidth: 175,
  },
  root: {
    borderRadius: "13px",
    "& .App1-MuiCardContent-root": {
      padding: "0px !important",
    },
  },
  chip: {
    height: "15px",
    borderRadius: "0px",
    marginLeft: "5px",
  },
  flexALign: {
    display: "flex",
    alignItems: "center",
  },
  backgroundLabel: {
    backgroundColor: "#DEE5EC",
    padding: "4px 8px",
    display: "flex",
    alignItems: "center",
    borderRadius: "4px",
    marginRight: "8px",
  },
  dot: {
    margin: "0px 6px",
    backgroundColor: "#B4BBC3",
    padding: "2px",
    borderRadius: "50%",
  },
  dialogPaper: {
    position: "absolute",
    right: 80,
    top: 50,
    minWidth: "300px",
    maxWidth: "300px",
    maxHeight: "100%",
  },
});

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const getText = (value = "", filler = "-") =>
  value?.toString() ? value : filler;

const { DISPENSE_HISTORY_READ } = actions;

function OrderDetails({ id, ...props }) {
  const dispatch = useDispatch();

  // Action States
  const dispenseHistory = useSelector(
    (state) => state?.phramcyFrameworkApiSlice?.dispenseHistoryRead
  );
  const data = dispenseHistory?.data?.[0];

  const [open, setOpen] = React.useState(false);
  const [currentLog, setCurrentLog] = React.useState([]);
  const classes = useStyles();
  const theme = useTheme();
  const dividerStyles = useDividerStyles();

  const handleClickOpen = (statusLog) => {
    setCurrentLog(statusLog);
    setOpen(true);
  };
  const handleClose = () => {
    setCurrentLog([]);
    setOpen(false);
  };

  useEffect(() => {
    dispatch(DISPENSE_HISTORY_READ({ id: id }));
  }, [id]);

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <div className={classes.flexALign} style={{ marginTop: "12px" }}>
            <div style={{ marginRight: "24px" }}>
              <div className={classes.flexALign}>
                <PillDark color={"#01205C"} />
                <Typography className={classes.heading}>Drug type</Typography>
              </div>
              <Typography className={classes.subContents}>
                {getText(data?.drugType?.longdesc)}
              </Typography>
            </div>
            <div style={{ marginRight: "24px" }}>
              <div className={classes.flexALign}>
                <TaskIcon color={"#01205C"} />
                <Typography className={classes.heading}>
                  Order Description
                </Typography>
              </div>
              <Typography className={classes.subContents}>
                {getText(data?.orderdescription)}
              </Typography>
            </div>
            <div style={{ marginRight: "24px" }}>
              <div className={classes.flexALign}>
                <Pills color={"#01205C"} />
                <Typography className={classes.heading}>Dosage</Typography>
              </div>
              <Typography className={classes.subContents}>{`${getText(
                data?.dosageValue
              )}${getText(data?.dosageUOM, "")}`}</Typography>
            </div>

            <div style={{ marginRight: "24px" }}>
              <div className={classes.flexALign}>
                <PillDark color={"#01205C"} />
                <Typography className={classes.heading}>
                  Drug Category
                </Typography>
              </div>
              <Typography className={classes.subContents}>
                {getText(data?.drug_category?.longdesc)}
              </Typography>
            </div>
          </div>

          <div className={classes.flexALign} style={{ marginTop: "24px" }}>
            <div style={{ marginRight: "24px" }}>
              <div className={classes.flexALign}>
                <DocumentBlack color={"#01205C"} />
                <Typography className={classes.heading}>Mode</Typography>
              </div>
              <Typography className={classes.subContents}>
                {getText(data?.presMode?.display)}
              </Typography>
            </div>
            <div style={{ marginRight: "24px" }}>
              <div className={classes.flexALign}>
                <Pills color={"#01205C"} />
                <Typography className={classes.heading}>Route</Typography>
              </div>
              <Typography className={classes.subContents}>
                {getText(data?.routeCode)}
              </Typography>
            </div>
            <div style={{ marginRight: "24px" }}>
              <div className={classes.flexALign}>
                <DocumentBlack color={"#01205C"} />
                <Typography className={classes.heading}>Form</Typography>
              </div>
              <Typography className={classes.subContents}>
                {getText(data?.formCode?.longdesc)}
              </Typography>
            </div>

            <div style={{ marginRight: "24px" }}>
              <div className={classes.flexALign}>
                <DocumentBlack color={"#01205C"} />
                <Typography className={classes.heading}>Nature</Typography>
              </div>
              <Typography className={classes.subContents}>
                {getText(data?.presNature?.display)}
              </Typography>
            </div>

            <div style={{ marginRight: "24px" }}>
              <div className={classes.flexALign}>
                <DocumentBlack color={"#01205C"} />
                <Typography className={classes.heading}>Generic</Typography>
              </div>
              <Typography className={classes.subContents}>
                {getText(data?.GenericDrug?.[0]?.longdesc)}
              </Typography>
            </div>
          </div>

          <div className={classes.flexALign} style={{ marginTop: "24px" }}>
            <div style={{ marginRight: "24px" }}>
              <div className={classes.flexALign}>
                <Clock color={"#01205C"} />
                <Typography className={classes.heading}>Duration</Typography>
              </div>
              <Typography className={classes.subContents}>{`${getText(
                data?.dosageDurationValue
              )} ${getText(data?.dosageDurationUOM, "")}`}</Typography>
            </div>
            <div style={{ marginRight: "24px" }}>
              <div className={classes.flexALign}>
                <Calender color={"#01205C"} />
                <Typography className={classes.heading}>Start Date</Typography>
              </div>
              <Typography className={classes.subContents}>
                {moment
                  .unix(data?.occurStartDateTime)
                  .format("DD-MM-YYYY HH:mm")}
              </Typography>
            </div>
            <div style={{ marginRight: "24px" }}>
              <div className={classes.flexALign}>
                <Calender color={"#01205C"} />
                <Typography className={classes.heading}>End Date</Typography>
              </div>
              <Typography className={classes.subContents}>
                {moment.unix(data?.occurEndDateTime).format("DD-MM-YYYY HH:mm")}
              </Typography>
            </div>

            <div style={{ marginRight: "24px" }}>
              <div className={classes.flexALign}>
                <StethoscopeIcon color={"#01205C"} />
                <Typography className={classes.heading}>Diagnosis</Typography>
              </div>
              <div style={{ display: "flex", marginLeft: "18px" }}>
                {data?.encounter_Id[0]?.health_of_service?.map((item, i) => (
                  <div className={classes.backgroundLabel}>
                    <Typography
                      className={classes.subContents}
                      style={{ color: "#101010", marginLeft: "0px" }}
                    >
                      {getText(item?.name)}
                    </Typography>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* ------------------ Practitioner Details Section Starts ------------------------- */}
        <div style={{ width: "300px", marginLeft: "45px" }}>
          <div style={{ marginTop: "16px" }}>
            <div style={{ width: "100%", marginTop: "10px" }}>
              <Card variant="outlined" className={classes.root}>
                <CardContent>
                  <div style={{ backgroundColor: "#F1F6FC" }}>
                    <div
                      style={{
                        display: "flex",
                        marginBottom: "12px",
                        paddingTop: "12px",
                        paddingLeft: "12px",
                      }}
                    >
                      <div>
                        <Avatar variant="rounded">
                          {
                            data?.encounter_Id?.[0]?.practitioner_details?.[0]
                              ?.id_name?.[0]
                          }
                        </Avatar>
                      </div>
                      <div
                        style={{
                          borderRight: "1px solid #DEE5EC",
                          paddingRight: "18px",
                        }}
                      >
                        <div>
                          <Typography className={classes.subContents}>
                            {getText(
                              data?.encounter_Id?.[0]?.practitioner_details?.[0]
                                ?.id_name
                            )}
                          </Typography>
                        </div>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <Typography
                            className={classes.heading}
                            style={{ marginLeft: "18px" }}
                          >
                            ID{" "}
                            {getText(
                              data?.encounter_Id?.[0]?.practitioner_details?.[0]
                                ?.id
                            )}
                          </Typography>
                          <div
                            style={{ backgroundColor: "#6A7888" }}
                            className={classes.dot}
                          ></div>
                          <Typography className={classes.heading}>
                            {`${getText(
                              data?.encounter_Id?.[0]?.practitioner_details?.[0]
                                ?.telecom?.[0]?.valueprefix,
                              ""
                            )}${
                              (getText(
                                ` ${data?.encounter_Id?.[0]?.practitioner_details?.[0]?.telecom?.[0]?.value}`
                              ),
                              "-")
                            }`}
                          </Typography>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        marginTop: "12px",
                        paddingTop: "12px",
                        paddingLeft: "12px",
                        paddingBottom: "16px",
                      }}
                    >
                      <div>
                        <div style={{ display: "flex" }}>
                          <Speciality />
                          <Typography className={classes.heading}>
                            Speciality Name
                          </Typography>
                        </div>
                        <div>
                          <Typography className={classes.subContents}>
                            {getText(
                              data?.encounter_Id?.[0]?.practitioner_details?.[0]
                                ?.speciality?.[0]?.coding?.[0]?.display
                            )}
                          </Typography>
                        </div>
                      </div>
                      <div style={{ marginTop: "10px" }}>
                        <div style={{ display: "flex" }}>
                          <LocationIcon />
                          <Typography className={classes.heading}>
                            Clinic
                          </Typography>
                        </div>
                        <div>
                          <Typography className={classes.subContents}>
                            {getText(
                              data?.encounter_Id?.[0]?.practitioner_details?.[0]
                                ?.clinic
                            )}
                          </Typography>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
      {/* /////////////////////// Practitioner Details Section Ends ////////////////////////////// */}

      {/* ------------------ Dispense Details Section Starts ------------------------- */}
      <div style={{ marginTop: "30px" }}>
        <div>
          <Typography className={classes.header}>Dispense Details</Typography>
          <Divider
            orientation="horizontal"
            flexItem
            classes={dividerStyles}
            // style={{ margin: theme.spacing(0, 1) }}
          />
        </div>
        {Array.isArray(data?.PH_OrderLineDispenseSchedule) &&
          data?.PH_OrderLineDispenseSchedule?.map((dispenseData) => (
            <>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>
                  <div
                    className={classes.flexALign}
                    style={{ marginTop: "24px" }}
                  >
                    <div style={{ marginRight: "24px" }}>
                      <div className={classes.flexALign}>
                        <Calender color={"#01205C"} />
                        <Typography className={classes.heading}>
                          Dispense Date
                        </Typography>
                      </div>
                      <Typography className={classes.subContents}>
                        {moment
                          .unix(dispenseData?.dispdate)
                          .format("DD-MM-YYYY HH:mm")}
                      </Typography>
                    </div>
                    <div style={{ marginRight: "24px" }}>
                      <div className={classes.flexALign}>
                        <Calender color={"#01205C"} />
                        <Typography className={classes.heading}>
                          From Date
                        </Typography>
                      </div>
                      <Typography className={classes.subContents}>
                        {moment
                          .unix(dispenseData?.dispfromdate)
                          .format("DD-MM-YYYY HH:mm")}
                      </Typography>
                    </div>
                    <div style={{ marginRight: "24px" }}>
                      <div className={classes.flexALign}>
                        <Calender color={"#01205C"} />
                        <Typography className={classes.heading}>
                          To Date
                        </Typography>
                      </div>
                      <Typography className={classes.subContents}>
                        {moment
                          .unix(dispenseData?.disptodate)
                          .format("DD-MM-YYYY HH:mm")}
                      </Typography>
                    </div>
                    <div style={{ marginRight: "24px" }}>
                      <div className={classes.flexALign}>
                        <Calender color={"#01205C"} />
                        <Typography className={classes.heading}>
                          Dispense Duration
                        </Typography>
                      </div>
                      <Typography className={classes.subContents}>
                        {`${getText(dispenseData?.dispdurval)}' '${getText(
                          dispenseData?.dispduruomText,
                          ""
                        )}`}
                      </Typography>
                    </div>
                    <div style={{ marginRight: "24px" }}>
                      <div className={classes.flexALign}>
                        <Clock color={"#01205C"} />
                        <Typography className={classes.heading}>
                          Balance Duration
                        </Typography>
                      </div>
                      <Typography className={classes.subContents}>
                        {getText(dispenseData?.balanceduration)}
                      </Typography>
                    </div>
                  </div>
                </div>
                <div style={{ marginTop: "24px" }}>
                  <div style={{ marginLeft: "24px" }}>
                    <div className={classes.flexALign}>
                      <Typography className={classes.heading}>
                        Status Log
                      </Typography>
                      <div
                        onClick={() =>
                          handleClickOpen(dispenseData?.statushistory)
                        }
                        style={{
                          marginLeft: "10px",
                          padding: "5px 7px 3px 7px",
                          backgroundColor: "#F1F6FC",
                        }}
                      >
                        <DocumentBlack color={"#01205C"} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {Array.isArray(dispenseData?.dispensedetails) &&
                dispenseData?.dispensedetails?.map((dispData) => (
                  <div style={{ marginTop: "20px", paddingBottom: "20px" }}>
                    <OrderDetailTable
                      {...props}
                      key={brand?.id}
                      disptype={drug?.disptype?.code}
                      dispenseData={dispData}
                      brand={brand}
                      imgId={drug?.drugPhotoId}
                      // isAnotherBrandAvailable={index !== drug?.brands?.length - 1}
                      batchQuantity={props?.batchQuantity}
                      // onBatchQuantityChange={(value, batch_inx) =>
                      //   props?.onBatchQuantityChange(
                      //     value,
                      //     brand?.id,
                      //     index,
                      //     batch_inx
                      //   )
                      // }
                      // handleChangebrandName={(value) => {
                      //   props.handleChangebrandName(value, index, brand?.id);
                      // }}
                      // handleDelete={() => props?.handleDelete(index)}
                      // handleAdd={() => props?.handleAdd(index)}
                      // isAdd={isaddfuncy(drug) && drug?.brands?.length - 1 === index}
                      // index={index}
                      // isIntravenous={isIntravenous}
                      // printLabel={() => printLabel(drug, index, brand)}
                      // handleDirectionSaveClick={(e) =>
                      //   props.handleDirectionSaveClick(e, index, brand)
                      // }
                      // printEnable
                    />
                  </div>
                ))}
            </>
          ))}
      </div>

      {/* /////////////////////// Dispense Details Section Ends ////////////////////////////// */}

      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        classes={{ paper: classes.dialogPaper }}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          <div style={{ display: "flex" }}>
            <DocumentBlack color={"#01205C"} />
            <Typography> Status Log</Typography>
          </div>
        </DialogTitle>
        <DialogContent dividers>
          {/* <VerticalLinearStepper /> */}
          <StatusLog data={currentLog} />
        </DialogContent>
      </Dialog>
    </>
  );
}

export default OrderDetails;

const drug = {
  id: 105,
  isIV: false,
  drugPhotoId: "",
  ScenarioName: "OP New",
  elapsedTime: "00:12",
  deliveringDispenseDuration: 0,
  delay: "2 days",
  dispenseStatus: "New",
  clinicalValidation: true,
  alerts: [
    {
      _key: "10007",
      _id: "PH_OrderLineAlertLogs/10007",
      _rev: "_eFR-aHK---",
      id: 14,
      identifier: ["IdentifierMaster/11107"],
      alertStatus: "CodingMaster/11071",
      alertCode: "CodingMaster/10825",
      severity: "CodingMaster/10629",
      patientID: "Patient/10215",
      orderlineID: "PH_OrderLine/10212",
      practitionerID: "Practitioner/10066",
      evidence: [
        {
          code: "CodingMaster/11075",
        },
      ],
      detail: "Left axis deviation greater than -90 degrees by EKG",
      reference: "Authority for issue",
      mitigation: [
        {
          action: "CodingMaster/11079",
          date: 1,
        },
      ],
      createdby: "",
      createddate: 1651226210,
      updatedby: "",
      updatedate: 1651226210,
      activestatus: true,
    },
  ],
  drugColor: "yellow",
  isHomeMedicationOrder: true,
  remarks: [
    {
      personName: "Dr. Roger Richards",
      type: "Verifier",
      role: "Consultant",
      addedOn: "24/02/2022 10:00",
      remark: "Instruction given by doctor in Rx",
    },
  ],
  name: "Amikacin Inj",
  doseStrength: "15null",
  route: "RECTAL",
  frequency: {
    code: "MKLI1237",
    unit: 3,
  },
  orderinfo: {
    title: "Oder Info",
    drugtype: "Medicine",
    drugcode: "DrugMaster/143241755",
    dosage: "15null",
    catagory: "Controlled",
    route: "RECTAL",
    form: "Injection",
    generic: "aspirin/phenyltoloxamine",
    mode: "Regular",
    nature: "Post-Discharge",
    duration: "30Days",
    startdate: "04-03-2022 12:00",
    enddate: "04-15-2022 11:59",
    diagnosis: ["Pathology - Haematology"],
    doctorName: "",
    id: "34562",
    contactnumber: "+91 95854 25622",
    specialityname: "General Medicine",
    clinicname: "ALASKA Facility",
    drugPhoto: "",
  },
  duration: "30 Days",
  speciality: "General Medicine",
  startDate: "04/03/2022, 12:00",
  endDate: "04/15/2022, 11:59",
  doctorName: "",
  brands: [
    {
      name: null,
      strength: "undefined undefined",
      route: "Oral",
      doseCount: 0,
      tabPerDose: 0,
      actualdoseCount: 0,
      batches: [],
      option: [
        {
          drugName: null,
          drugNameShort: null,
          packSizeApplicability: [],
          seqno: 0,
          drugNameLong: null,
        },
      ],
      drugName: null,
      drugNameShort: null,
      packSizeApplicability: [],
      seqno: 0,
      drugNameLong: null,
    },
  ],
  additives: [],
  dispenseDuration: -18,
  dispenseDurationValue: {
    dosageDurationUOM: "DrugUOM/11616",
    drug_id: "DrugMaster/143241755",
    dispStartDate: 1651708800,
    dispEndDate: 1650153600,
    dispDuration: -18,
    maxDefaultDurationVal: 5,
    nextRefillDate: 0,
  },
  OrderId: "PH_OrderLine/10212",
  drug_id: "DrugMaster/143241755",
  FreqDetls: [
    {
      dose: "",
      doseTime: "",
      baseFreq: "DBA",
      weekDay: "Monday",
      day: 2,
      fromDay: 0,
      toDay: 0,
      fromDate: 0,
      toDate: 0,
      adminDosageInstruction: "",
    },
  ],
  GenericDrug: [
    {
      _key: "45925",
      _id: "GenericDrugMaster/45925",
      _rev: "_dvu2-nW--6",
      genericingrlistid: 354,
      id: 309,
      longdesc: "aspirin/phenyltoloxamine",
      mappedextsourcedb: "FDB",
      shortdesc: "aspirin/phenyltoloxamine",
      activestatus: true,
    },
  ],
  PH_OrderLineAlertLogs: [
    {
      _key: "10007",
      _id: "PH_OrderLineAlertLogs/10007",
      _rev: "_eFR-aHK---",
      id: 14,
      identifier: ["IdentifierMaster/11107"],
      alertStatus: "CodingMaster/11071",
      alertCode: "CodingMaster/10825",
      severity: "CodingMaster/10629",
      patientID: "Patient/10215",
      orderlineID: "PH_OrderLine/10212",
      practitionerID: "Practitioner/10066",
      evidence: [
        {
          code: "CodingMaster/11075",
        },
      ],
      detail: "Left axis deviation greater than -90 degrees by EKG",
      reference: "Authority for issue",
      mitigation: [
        {
          action: "CodingMaster/11079",
          date: 1,
        },
      ],
      createdby: "",
      createddate: 1651226210,
      updatedby: "",
      updatedate: 1651226210,
      activestatus: true,
    },
  ],
  PH_OrderLineDispenseSchedule: [],
  PH_OrderLinePerdoseSchedule: [],
  _id: "PH_OrderLine/10212",
  _key: "10212",
  alloweddisptype: null,
  disptype: null,
  dosageDurationUOM: "Days",
  dosageDurationUOM_id: "DrugUOM/11616",
  dosageDurationValue: 30,
  dosageFreqCode: "MKLI1237",
  dosageFreqCode_id: "FrequencyMaster/10167",
  dosageUOM: null,
  dosageUOM_id: null,
  dosageValue: 15,
  drugCode: "DrugMaster/143241755",
  drugName: "Amikacin (PF) Injection - 2 ml",
  drugPhoto: [
    {
      _key: "10730",
      _id: "AttachmentMaster/10730",
      _rev: "_eBEH5cS--_",
      date: "",
      url: "",
      id: 422,
      fileName: "",
      fileid: "",
      filetype: "",
      objectid: "",
      createdby: "",
      createddate: 1650098564,
      updatedby: "",
      updatedate: 1650098564,
      activestatus: true,
    },
  ],
  drugType: {
    _key: "10003",
    _id: "DrugType/10003",
    _rev: "_eE9VYkC---",
    activestatus: true,
    createdby: "",
    createddate: 1633513573,
    drugtype: "DRGTYP-001",
    id: 3,
    longdesc: "Medicine",
    shortdesc: "MEDICINE",
    status: true,
    updatedate: 1633513573,
    updatedby: "",
  },
  drug_category: {
    _key: "10005",
    _id: "DrugCategory/10005",
    _rev: "_eC9tHB2---",
    activestatus: true,
    createdby: "",
    createddate: 1633512333,
    drugcategory: "DRGCATG-002",
    id: 2,
    longdesc: "Controlled",
    shortdesc: "CONTROL",
    status: true,
    updatedate: 1633512333,
    updatedby: "",
  },
  encounter_Id: [
    {
      Organization_id: 3,
      ServiceRequest_id: 0,
      _id: "Encounter/10325",
      _key: "10325",
      _rev: "_eBwHHWy---",
      accompanied_person: [
        {
          id_type: "",
          id: "",
          name: "",
          relationship: "",
        },
      ],
      account_id: [],
      activestatus: true,
      appointmentId: [748],
      class: "",
      classhistory: [
        {
          class: "",
          period: "",
        },
      ],
      createdby: "",
      createddate: 1644227528,
      destination: "",
      device_details: [
        {
          category: "",
          type: "",
          name: "",
        },
      ],
      diagnosis: [],
      dietPreference: [],
      dischargeDisposition: "",
      encounterdate: 1644227530,
      episodeOfCare_id: 0,
      files: [],
      health_of_service: [
        {
          category: "Aged Care",
          name: "Pathology - Haematology",
          type: "Therapy",
        },
      ],
      hospitalization: [
        {
          preAdmissionIdentifier: "",
          origin: "",
          admitSource: "",
        },
      ],
      id: 325,
      identifier: [
        {
          user: "",
          system: "",
          value: "",
          period: [
            {
              start: 1644227530,
              end: 0,
              id: 0,
            },
          ],
          assigner: "",
          Type: [
            {
              text: "",
              coding: [
                {
                  system: "",
                  version: "",
                  code: "",
                  display: "",
                  userSelected: true,
                  id: 0,
                  Type: "",
                },
              ],
              id: 0,
              Type: "",
            },
          ],
          id: 0,
        },
      ],
      length: "",
      location: [
        {
          location_id: "LocationMaster/10010",
          status: "",
          period: "",
          physicalType: "",
        },
      ],
      mode: "direct",
      participant: [
        {
          type: ["CodingMaster/12338"],
          period: "",
          Practitioner_id: 11,
          PractitionerRole_id: 25,
          RelatedPerson_id: 0,
        },
      ],
      patient_id: [
        {
          _id: "Patient/10057",
          alias: "MRN00_151",
          name: [
            {
              family: "Lakshmi",
              given: "Shivani",
              prefix: "Mr",
              suffix: "Junior",
              text: "Shiv",
              use: "Old",
            },
          ],
        },
      ],
      period: "",
      practitioner_details: [
        {
          clinic: "ALASKA Facility",
          id_name: "Nurse",
          role: "Test Nurse",
          speciality: [
            {
              Type: "SPECIALTY",
              _id: "CodeableConceptMaster/10452",
              _key: "10452",
              _rev: "_dsII2HG-CC",
              activestatus: true,
              coding: [
                {
                  _key: "10453",
                  _id: "CodingMaster/10453",
                  _rev: "_dsII2s6-BL",
                  Type: "SPECIALTY",
                  activestatus: true,
                  code: "SP005",
                  createdby: "",
                  createddate: 1635950774,
                  display: "General Medicine",
                  gmconfigvalues: {},
                  id: 453,
                  shortdesc: "General Medicine",
                  status: true,
                  updatedate: 1635950774,
                  updatedby: "",
                },
              ],
              createdby: "",
              createddate: 1635950774,
              id: 453,
              status: true,
              text: "SP005",
              updatedate: 1635950774,
              updatedby: "",
            },
          ],
          type: "Consultation",
        },
      ],
      priority: "",
      reAdmission: "",
      reasonCode: "",
      reasonReference: "CodingMaster/10066",
      relationship: "",
      serviceType: "Other Visits",
      specialArrangement: [],
      specialCourtesy: [],
      status: "CodingMaster/10807",
      statushistory: [
        {
          period: ["periodMaster/20084"],
          status: "CodingMaster/10725",
        },
        {
          period: ["periodMaster/20085"],
          status: "CodingMaster/10807",
        },
        {
          period: ["periodMaster/20086"],
          status: "CodingMaster/10807",
        },
        {
          period: ["periodMaster/20087"],
          status: "CodingMaster/10807",
        },
        {
          period: ["periodMaster/20088"],
          status: "finished",
        },
        {
          status: "CodingMaster/10807",
          period: ["periodMaster/20089"],
        },
      ],
      type: [
        {
          display: "CodingMaster/10263",
        },
      ],
      updatedate: 1644296102,
      updatedby: "",
      visit_type: "Other Visits",
    },
  ],
  formCode: {
    _key: "10009",
    _id: "DosageForm/10009",
    _rev: "_dsII5FC--A",
    activestatus: true,
    createdby: "",
    createddate: 1636354122,
    dosageform: "INJECTION",
    longdesc: "Injection",
    shortdesc: "Injection",
    status: true,
    updatedate: 1637738037,
    updatedby: "",
  },
  ivInfusionRateUOM: "",
  ivInfusionRateValue: 0,
  ivInfusionRatetext: null,
  mappedItems: [
    {
      drugName: null,
      drugNameShort: null,
      packSizeApplicability: [],
      seqno: 0,
      drugNameLong: null,
    },
  ],
  nextrefilldate: 0,
  occurEndDateTime: 1650047340,
  occurStartDateTime: 1648924200,
  orderdescription: "Amikacin Inj",
  ordertype: "Regular",
  patient_Id: "Patient/10215",
  presMode: {
    _key: "10301",
    _id: "CodingMaster/10301",
    _rev: "_dsII2sy--Y",
    Type: "ORDERMODE",
    activestatus: true,
    code: "REGULAR",
    createdby: "",
    createddate: 1639666388,
    display: "Regular",
    gmconfigvalues: {},
    id: 301,
    shortdesc: "Regular",
    status: true,
    system: "",
    updatedate: 1639666388,
    updatedby: "",
    userSelected: true,
    version: "1",
  },
  presNature: {
    _key: "10622",
    _id: "CodingMaster/10622",
    _rev: "_dsII2sy-A-",
    Type: "ORDERNATURE",
    activestatus: true,
    code: "Post-Discharge",
    createdby: "",
    createddate: 1636347368,
    display: "Post-Discharge",
    gmconfigvalues: {},
    id: 622,
    shortdesc: "Post-Discharge",
    status: true,
    updatedate: 1636347368,
    updatedby: "",
  },
  prescripionType: "",
  prescripionTypeName: null,
  requestor: [
    {
      practId: [],
    },
  ],
  routeCode: "RECTAL",
  routeCode_id: "DrugRoutes/10077",
  scenarioId: [
    {
      _key: "10019",
      _id: "queuescenarios/10019",
      _rev: "_eEuKRI2---",
      queueid: "queue/10013",
      scenarioid: "SC16",
      scenarioname: "OP New",
      scenariodescription: "",
      scenariocriteria: ["Rules/10717"],
      bgcolor: "#fcefe8",
      textcolor: "#2a3c50",
      icon: "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMTUuMjU0IiBoZWlnaHQ9Ijc3LjYzOCIgdmlld0JveD0iMCAwIDExNS4yNTQgNzcuNjM4Ij4KICA8ZyBpZD0iXzc4MTUiIGRhdGEtbmFtZT0iNzgxNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCkiPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV80OTQ2MyIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNDk0NjMiIHdpZHRoPSI1LjYwNiIgaGVpZ2h0PSIyLjEwNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTA3LjA3MyAxNy44OCkiIGZpbGw9IiNhZWMzZmYiLz4KICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfNDk0NjQiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDQ5NDY0IiB3aWR0aD0iMy4wNDgiIGhlaWdodD0iMC4zMDIiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEwOS42MzIgMTguMjQ1KSIgZmlsbD0iI2ZmZiIvPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV80OTQ2NSIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNDk0NjUiIHdpZHRoPSI1LjYwNiIgaGVpZ2h0PSIyLjEwNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOTkuMzM0IDE3Ljg4KSIgZmlsbD0iI2FlYzNmZiIvPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV80OTQ2NiIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNDk0NjYiIHdpZHRoPSIzLjA0OCIgaGVpZ2h0PSIwLjMwMiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAxLjg5MiAxOC4yNDUpIiBmaWxsPSIjZmZmIi8+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzQ5NDc1IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA0OTQ3NSIgd2lkdGg9IjMuNTgxIiBoZWlnaHQ9IjEuOTk4IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDUuOTU5IDIwLjAxNCkiIGZpbGw9IiNmZmYiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzk0Mzg1IiBkYXRhLW5hbWU9IlBhdGggOTQzODUiIGQ9Ik03MjguOTYsMTA1MC40NDdoMTQuOTVsMi4wNTEtMTEuMzc3aC0xNC45NVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02MzIuODgyIC0xMDIxLjQ0OCkiIGZpbGw9IiMxNjM1NjAiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzk0Mzg2IiBkYXRhLW5hbWU9IlBhdGggOTQzODYiIGQ9Ik03MjUuOTUsMTA1MC40NDdINzQwLjlsMi4wNTEtMTEuMzc3SDcyOFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02MjkuNjMyIC0xMDIxLjQ0OCkiIGZpbGw9IiMyNjMyMzgiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzk0Mzg3IiBkYXRhLW5hbWU9IlBhdGggOTQzODciIGQ9Ik04MDAuMjgyLDExMzEuMzI4aDMuNDRsLS43NTMtNy41MDhINzk5LjUzWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTY5Ni4yNDUgLTEwOTkuNDY5KSIgZmlsbD0iIzI2MzIzOCIvPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV80OTUwNCIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNDk1MDQiIHdpZHRoPSI0Ljg1NSIgaGVpZ2h0PSIwLjIxNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAyLjM2IDMxLjY0MykiIGZpbGw9IiMxNjM1NjAiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzk0NDU5IiBkYXRhLW5hbWU9IlBhdGggOTQ0NTkiIGQ9Ik0xMjA1LjA0OSwxNzA3LjI1SDEyMDFhOS43NDksOS43NDksMCwwLDEsLjMyMy0xLjQ1NCwzLjk4OSwzLjk4OSwwLDAsMSwuMjI5LS41ODNjLjQtLjc4NiwyLjg5NC0uMjg2LDIuODk0LS4yODZhMS45MzIsMS45MzIsMCwwLDEsLjQxNC45NkE4LjA1OSw4LjA1OSwwLDAsMSwxMjA1LjA0OSwxNzA3LjI1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExMjkuNDQzIC0xNjM0LjMpIiBmaWxsPSIjMjMzODYyIi8+CiAgICA8cGF0aCBpZD0iUGF0aF85NDQ2MCIgZGF0YS1uYW1lPSJQYXRoIDk0NDYwIiBkPSJNMTI5Ny43MjQsOTU3LjA4cy0zLjIyNi41NjYtMy45NTUsMi40Ny00Ljg1LDMyLjY2LTQuODUsMzIuNjYsMi4wNCwxLjYxNyw2LjQyLDEuMDM3UzEyOTcuNzI0LDk1Ny4wOCwxMjk3LjcyNCw5NTcuMDhaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTIyOS41NTIgLTk0NS45NjcpIiBmaWxsPSIjMzI0OTUzIi8+CiAgICA8cGF0aCBpZD0iUGF0aF85NDQ2MSIgZGF0YS1uYW1lPSJQYXRoIDk0NDYxIiBkPSJNMTM2My4zOTIsMTY4Ni44NjVhMi4xODgsMi4xODgsMCwwLDEtLjI4LDEuMjc4SDEzNTUuMWExLjM4MywxLjM4MywwLDAsMSwxLjIxMi0uODU5LDYuMDgsNi4wOCwwLDAsMCwzLjI0MS0xLjUsMi40MTUsMi40MTUsMCwwLDAsLjYyNy0xLjEzNmMuMzc3LTEuNjc3LDMuMTE1LjUxNCwzLjExNS41MTRBMTMuNjQxLDEzLjY0MSwwLDAsMSwxMzYzLjM5MiwxNjg2Ljg2NVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMzAwLjAyMSAtMTYxNS4xOTMpIiBmaWxsPSIjMjMzODYyIi8+CiAgICA8cGF0aCBpZD0iUGF0aF85NDQ2MiIgZGF0YS1uYW1lPSJQYXRoIDk0NDYyIiBkPSJNMTIzNy44MTUsMTI3MS45ODVjLjg5NS4yODUsMi42MDYsMS4xNTcsMy42OTIuNzQ3LjctLjI2NCw0LjYyNy0xMS42MTgsNC44ODItMTYuNTgzYTEyLjcsMTIuNywwLDAsMSwuMi0xLjQ3OWMuMjMzLTEuMjgyLjYzNS0zLjA0MywxLjExMS00Ljk4NiwxLjI1Ni01LjIwNywyLjk1NS0xMS43MjEsMi45MTgtMTMuOC0uMDU3LTMuMjMyLTkuNjMtLjY3Ny05LjYzLS42NzdhMzQuNjI3LDM0LjYyNywwLDAsMC0uNzksNi40ODhjLS4yNiw3LjYyMS0uOTc0LDIwLjQ4Mi0yLjkxOCwyOS40MjFBLjc2MS43NjEsMCwwLDAsMTIzNy44MTUsMTI3MS45ODVaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTE3Ny44OTMgLTEyMDEuMTI5KSIgZmlsbD0iIzIzMzg2MiIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTQ0NjMiIGRhdGEtbmFtZT0iUGF0aCA5NDQ2MyIgZD0iTTExNzkuNTg0LDEyNDEuNDYzbDUuMDYsMzYuNjc3YTkuOSw5LjksMCwwLDAsMy45NTEuMTA3czEuNDgxLTE5LjUwNywxLjM1OC0yNC4yMjQsMS4wNjMtMTIuNjIyLS4yNzEtMTMuNDkxUzExNzkuNTg0LDEyNDEuNDYzLDExNzkuNTg0LDEyNDEuNDYzWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExMTMuMDE3IC0xMjA2LjY5OSkiIGZpbGw9IiMyYjQ3OGIiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzk0NDY0IiBkYXRhLW5hbWU9IlBhdGggOTQ0NjQiIGQ9Ik0xMTk0LjU0MSw5NTIuOTVzLTUuMzE5LTMuNDM5LTkuMTMtMS42OGE3LjEzOCw3LjEzOCwwLDAsMC0xLjgsMS42MDljLTEuMzc5LDEuNTItNC4wNzMsMjUuNjU1LTQuMDczLDI1LjY1NXM3LjY0OCwyLjU5LDE1LS44NzlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTExNy4yMzUgLTk0MC4xNTcpIiBmaWxsPSIjZmZmIi8+CiAgICA8cGF0aCBpZD0iUGF0aF85NDQ2NSIgZGF0YS1uYW1lPSJQYXRoIDk0NDY1IiBkPSJNMTMwOC45NjQsOTU2cy01LjM4NCwyLjIwNi02LjExMywzLjktNC40MTEsMTYuOTY3LTQuNDExLDE4LjE4NywzLjIsMy45NjksMy44NjksMmMuNTUxLTEuNjM1LDQuNjQ3LTE1LjIxMSw1LjYyOS0xOC4zODlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTI0MS4wOTQgLTk0NC45NzMpIiBmaWxsPSIjMzI0OTUzIi8+CiAgICA8cGF0aCBpZD0iUGF0aF85NDQ2NiIgZGF0YS1uYW1lPSJQYXRoIDk0NDY2IiBkPSJNMTIzMi43NSw5MjEuMzcxYTYuMDU2LDYuMDU2LDAsMCwwLDQuMTY2LS44NDksMTEuOTc5LDExLjk3OSwwLDAsMS0uODg3LTMuMTM2Yy0uMDA1LS4wMzctLjAwOS0uMDczLS4wMTMtLjEwOGEzLjIzNiwzLjIzNiwwLDAsMS0uMDE0LS43MTloLTMuMDM5cy0uODMuMzgtLjgzLjY0M3YuNGMtLjAwNS4zNDktLjAyLjY1NS0uMDM4LjkxN2E4LjM4Niw4LjM4NiwwLDAsMS0uMTU5LDEuMjU0UzEyMzEuNTYzLDkyMS4xMzgsMTIzMi43NSw5MjEuMzcxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExNjMuNzYyIC05MDguNjYzKSIgZmlsbD0iI2ZmYjI3ZCIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTQ0NjciIGRhdGEtbmFtZT0iUGF0aCA5NDQ2NyIgZD0iTTEyNDIuMjUsOTI1LjAyMWE0LjIsNC4yLDAsMCwwLDMuOTM4LTEuMTM2Yy4wNDItLjA0Ni4wNjQtLjA3NC4wNjQtLjA3NC0uMDI1LS4wMTItLjA1LS4wMjMtLjA4LS4wMzRhNy4xNDMsNy4xNDMsMCwwLDAtMy44OS4zMjdDMTI0Mi4yODIsOTI0LjQ1NCwxMjQyLjI2OCw5MjQuNzYxLDEyNDIuMjUsOTI1LjAyMVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTczLjkyMiAtOTE1LjE2MikiIGZpbGw9IiNlMjkxNWEiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzk0NDY4IiBkYXRhLW5hbWU9IlBhdGggOTQ0NjgiIGQ9Ik0xMjMyLjE3OSw4NDUuNjQ1Yy0uNDExLDIuMjE0LTMuMjY4LDIuMTQzLTQuNSwyLS4zNDgtLjAzOC0uNTY2LS4wNzktLjU2Ni0uMDc5LS4zOTItLjEtLjYxMS0uNzIyLS43MTUtMS41M2ExMi42LDEyLjYsMCwwLDEsLjMyMy00LjU0OWMuNDA3LS45LDEuMTczLTEuODgxLDQuMDQ5LTEuMTc2UzEyMzIuNzA3LDg0Mi44MDksMTIzMi4xNzksODQ1LjY0NVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMTU5LjE2MSAtODM4LjI0OCkiIGZpbGw9IiNmZmIyN2QiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzk0NDY5IiBkYXRhLW5hbWU9IlBhdGggOTQ0NjkiIGQ9Ik0xMjAyLjk2Nyw4MTkuMWE2LjYyMiw2LjYyMiwwLDAsMSwxLjk4NS0xLjYyLDQuOCw0LjgsMCwwLDEsMy43MTguMDMyYzIuMzUsMS4wMzIsMi45NjQsMi44MzEsMS43MTcsNS42MzItMS4zMTcsMi45NjEtMi41NzEsMi42MjgtMi41NzEsMi42MjhzLjI2Ni0uMTY1LjIzOC0xLjA4OGEuODUzLjg1MywwLDAsMC0uMDA2LS4xMzQuNjIxLjYyMSwwLDAsMSwuMi0uNWMuMjkyLS4yNi40MzQtMS4wNDguMTktMS4yNy0uMjk1LS4yNjQtLjcwOS4wNTctLjg0Mi4zYS4zNjEuMzYxLDAsMCwxLS41MTUuMTE0Yy0uNzMyLS40NjMtLjI1Ni0xLjM4OC0uOTUzLTEuOTUzcy0yLjExNy0uMDkxLTMuMTY1LS41NDJDMTIwMS41ODcsODIwLjE4MSwxMjAyLjY3MSw4MTkuNTA1LDEyMDIuOTY3LDgxOS4xWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExMzUuNTE0IC04MTcuMDkyKSIgZmlsbD0iIzI2MzIzOCIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTQ0NzAiIGRhdGEtbmFtZT0iUGF0aCA5NDQ3MCIgZD0iTTExNjAuNDU1LDk5My41MjNjLjQ2NC4xMTkuOTIyLjIxOCwxLjM3Ny4yOTIuNC4wNjkuOC4xMiwxLjIwNi4xNTNhMTkuNiwxOS42LDAsMCwwLDcuMjM1LS44ODhxLjktLjI1OSwxLjg2OS0uNTg1Yy4wNjgtLjAyMy0uMTc2LTcuMDg5LS40NTgtMTQuMzc3LS4wMjktLjc1My0uMDU4LTEuNTA4LS4wODgtMi4yNTktLjAxMy0uMzE4LS4wMjUtLjYzNS0uMDM3LS45NTMtLjI1NS02LjQ0Ni0uNTEtMTIuMjY3LS41NjItMTIuNTgxLS4xMjItLjcwOS0uMjM4LTEuMzE0LS4zNjEtMS44MzdhNC42NTksNC42NTksMCwwLDAtMS44LTMuMDg1Yy0uMS0uMDczLS44ODQtLjQ3MS0xLjU3OS0uODE3LS41NzYtLjI4Ni0xLjA4OS0uNTM2LTEuMDg5LS41MzZoMGEzLjAyNCwzLjAyNCwwLDAsMC0uNzk0LDEuMzc1LDQ5LjM4Niw0OS4zODYsMCwwLDAtMS41LDQuOTkzLjAyMi4wMjIsMCwwLDAsMCwuMDA4aDBjLS4yNTYsMS0uNDQsMS43ODUtLjQ5MiwyLjAwOS0uMDg4LjM3OS0uMjA2LDEuMTExLS4zNDQsMi4xLS4xODcsMS4zNDktLjQxLDMuMTg3LS42NDgsNS4yNzEtLjAyNC4yMTQtLjA0OC40My0uMDcyLjY0OS0uMDI4LjI0OS0uMDU2LjUtLjA4NS43NTctLjAwOS4wNzktLjAxNy4xNjQtLjAyNy4yNDdDMTE2Mi4xMTQsOTc0LjI5NCwxMTYwLjQyMyw5OTMuMSwxMTYwLjQ1NSw5OTMuNTIzWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwOTMuMzI5IC05NDUuMDE5KSIgZmlsbD0iIzQ1NWE2NCIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTQ0NzEiIGRhdGEtbmFtZT0iUGF0aCA5NDQ3MSIgZD0iTTExNzAuOTkzLDEwNzYuMTY1YzEuNTM1LS4wNjgsOC45NDQtLjQsOS4wOC0uNjIyLjE1Mi0uMjQ0LTMuMDA3LTcuNjc0LTMuMDA3LTcuNjc0LDAsLjAxNS42MTYsNi4wMTEtNC4yNzcsNi44LS41MTEuMDc5LjA3OS43My0uMjcxLjhDMTE3Mi40OSwxMDc1LjcyMiwxMTcxLjAyMSwxMDc1LjkxLDExNzAuOTkzLDEwNzYuMTY1WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExMDIuMDkgLTEwNDcuOTYxKSIgZmlsbD0iIzMyNDk1MyIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTQ0NzIiIGRhdGEtbmFtZT0iUGF0aCA5NDQ3MiIgZD0iTTExNTIuMiwxMTc5LjRsMS42NzIuOTY3YTI5LjE2MSwyOS4xNjEsMCwwLDAsNi4zLDIuMjk1cS41MDcuMTM4LDEuMDQ5LjI1OWMtLjAyOS0uNzUzLS4wNTgtMS41MDgtLjA4Ny0yLjI1OGE5LjQxNCw5LjQxNCwwLDAsMCwxLjIxMi0uMTY3Yy0uMDEzLS4xLS4wMjYtLjItLjAzOS0uMy0uNDEtLjE2OC0uODE4LS4zMy0xLjIxMi0uNDg0LS4zMTgtLjEyNS0uNjI5LS4yNDQtLjkyMy0uMzU1LTEuMzI1LS41LTIuMzA3LS44NDQtMi4zMDctLjg0NGwtMy45MjIsMS4yNDJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTA4Mi44NzEgLTExNDkuODE4KSIgZmlsbD0iIzMyNDk1MyIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTQ0NzMiIGRhdGEtbmFtZT0iUGF0aCA5NDQ3MyIgZD0iTTEyOTQuNzE4LDk0OC4yMmEyLjYzOCwyLjYzOCwwLDAsMC0xLjAyNSwxLjA0OWwtLjQxMyw1LjI2NXMuODgyLTMuODY0LDEuMzMtNS42MUEyLjkzMSwyLjkzMSwwLDAsMCwxMjk0LjcxOCw5NDguMjJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTIyNi40MzggLTkzNy44MSkiIGZpbGw9IiM0NTVhNjQiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzk0NDc0IiBkYXRhLW5hbWU9IlBhdGggOTQ0NzQiIGQ9Ik0xMjg0LjUzOSw5MTMuOWEuODguODgsMCwwLDEtLjcuMzM5Yy0uNC0uMDQ5LS43LS4xNzYtLjc1NC0uMzYxcy0uMDc5LS4zMTgtLjA3OS0uMzE4QTIuNywyLjcsMCwwLDEsMTI4NC41MzksOTEzLjlaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTIxNS40NDMgLTkwNS44OTIpIiBmaWxsPSIjZmZmIi8+CiAgICA8cGF0aCBpZD0iUGF0aF85NDQ3NSIgZGF0YS1uYW1lPSJQYXRoIDk0NDc1IiBkPSJNMTI3My4wNDgsMTE1MS44bC0xLjIzOC0uNTc4YTEwLjQwNiwxMC40MDYsMCwwLDAtMS4xOC0uMzNsLjAzNi41LjkxMi42MjYsMS40LjcxOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMjAyLjk3IC0xMTI0LjM5KSIgZmlsbD0iI2ZmYjI3ZCIvPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV80OTU0NSIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNDk1NDUiIHdpZHRoPSI1Ljk0IiBoZWlnaHQ9IjQuNzciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY3LjQgMzAuMjgzKSByb3RhdGUoLTE2Ni44MSkiIGZpbGw9IiNlNzk4NmYiLz4KICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfNDk1NDYiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDQ5NTQ2IiB3aWR0aD0iMy4yMjkiIGhlaWdodD0iMC42ODQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDY4LjE0NSAyNy4xMDgpIHJvdGF0ZSgtMTY2LjgxKSIgZmlsbD0iI2ZmZiIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTQ0NzYiIGRhdGEtbmFtZT0iUGF0aCA5NDQ3NiIgZD0iTTEyNzUuMSwxMTYyLjMxNnMtMS40ODEuMDQ1LTIuMzEzLS4wMzZhMy4wMSwzLjAxLDAsMCwxLTEuODQ3LTEuMTExYy0uMDUyLS4yMDYuMDY5LS41NzMsMS4wMjMtLjYyNC44MTEtLjA0NCwxLjc5LDAsMS43OSwwbDEuOTc0LjQ1NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMjA1LjY3NCAtMTEzMy4yNjEpIiBmaWxsPSIjZmZiMjdkIi8+CiAgICA8cGF0aCBpZD0iUGF0aF85NDQ3NyIgZGF0YS1uYW1lPSJQYXRoIDk0NDc3IiBkPSJNMTExMy45NzQsOTc0LjYxNGE5LjkzMiw5LjkzMiwwLDAsMCwxLjc4MS42MWguMDA5YTMyLjA3NywzMi4wNzcsMCwwLDAsNi4xODguNjkyYy4zMjcsMCwuNjUtLjAxNi45NjEtLjA0MWE5LjQxLDkuNDEsMCwwLDAsMS4yMTItLjE2OCwzLjc3MywzLjc3MywwLDAsMCwxLjkzNy0uOTE0YzMuMy0zLjM2Ni0xLjgtMTUuNDQ2LTIuODc3LTE2LjYyMS0xLjI1My0xLjM3My0zLjU0Mi0xLjg1NC00LjgwNi0yLjAxOWwtLjE1Mi0uMDJjLS40NDQtLjA1Mi0uNzI5LS4wNjMtLjc0NS0uMDY0aDBzLjEuMzE4LjI2NS44NTljLjA2NC4yMDkuMTM5LjQ1MS4yMjIuNzIyLjc3NiwyLjU0LDIuMjc0LDcuNTM3LDIuOTM3LDEwLjM1NGE3LjI1NSw3LjI1NSwwLDAsMSwuMzEyLDEuOTljLS4yNTcuOTYyLTIuOTI3LDEuNDU3LTQuNjE5LDEuNjc2YTEwLjA5MSwxMC4wOTEsMCwwLDEtMS4yNTEuMDc5QzExMTQuMzEzLDk3MS41OTQsMTExMy45NzQsOTc0LjYxNCwxMTEzLjk3NCw5NzQuNjE0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEwNDQuNjQ1IC05NDUuMDM3KSIgZmlsbD0iIzQ1NWE2NCIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTQ0NzgiIGRhdGEtbmFtZT0iUGF0aCA5NDQ3OCIgZD0iTTEyMjEuNzY0LDk0Ny4xNGEyLjYyOCwyLjYyOCwwLDAsMSwxLjUxNC44NTFzLTMuNTkzLDYuMjkyLTMuNTc3LDYuMjM2UzEyMjAuODcyLDk0Ny45MTMsMTIyMS43NjQsOTQ3LjE0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTExNDkuMTU3IC05MzYuODE2KSIgZmlsbD0iIzMyNDk1MyIvPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV80OTU0NyIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNDk1NDciIHdpZHRoPSI4NC44OTMiIGhlaWdodD0iNDIuNzg2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyNy42MzEgMzQuMjc4KSIgZmlsbD0iI2U3OTg2ZiIvPgogICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV80OTU0OCIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNDk1NDgiIHdpZHRoPSI5MC4zNTMiIGhlaWdodD0iMy40OTkiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDI0LjkwMSAzMS44NTkpIiBmaWxsPSIjZmZmIi8+CiAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzQ5NTQ5IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA0OTU0OSIgd2lkdGg9Ijg0Ljg5MyIgaGVpZ2h0PSI2LjkwOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjcuNjMxIDYyLjU3OSkiIGZpbGw9IiNmZmYiLz4KICAgIDxwYXRoIGlkPSJQYXRoXzk0NDg3IiBkYXRhLW5hbWU9IlBhdGggOTQ0ODciIGQ9Ik03OTMuOTQ0LDEzMzQuODc3YTUuMzUyLDUuMzUyLDAsMSwwLTMuNzg0LTEuNTY3QTUuMzUxLDUuMzUxLDAsMCwwLDc5My45NDQsMTMzNC44NzdabTAtMTAuMjExYTQuODYsNC44NiwwLDEsMS0zLjQzNiwxLjQyM0E0Ljg2LDQuODYsMCwwLDEsNzkzLjk0NCwxMzI0LjY2NloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03MjMuODkgLTEyODAuNDE2KSIgZmlsbD0iI2ZmZiIvPgogICAgPHBhdGggaWQ9IlBhdGhfOTQ0ODgiIGRhdGEtbmFtZT0iUGF0aCA5NDQ4OCIgZD0iTTgxMi40MSwxMzUwLjYzM2gyLjU4M3YtMi41ODNoMS43NDZ2Mi41ODNoMi41ODR2MS43NDZoLTIuNTg0djIuNTgzaC0xLjc0NnYtMi41ODNIODEyLjQxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTc0NS44MDggLTEzMDIuMzk3KSIgZmlsbD0iI2ZmZiIvPgogICAgPGcgaWQ9Ikdyb3VwXzk1MTEwIiBkYXRhLW5hbWU9Ikdyb3VwIDk1MTEwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjkwMSA0LjM5OCkiPgogICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzQ5NDQ3IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA0OTQ0NyIgd2lkdGg9IjAuOTk1IiBoZWlnaHQ9IjAuODE2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg4LjI4OSAxNC41ODkpIiBmaWxsPSIjYWVjM2ZmIi8+CiAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGVfNDk0NDgiIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDQ5NDQ4IiB3aWR0aD0iMC4wNyIgaGVpZ2h0PSIxLjEwMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOC43NzUgMTMuMjA4KSIgZmlsbD0iI2NkZTBmYiIvPgogICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzQ5NTI1IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSA0OTUyNSIgd2lkdGg9IjIuMDUxIiBoZWlnaHQ9IjMuNDUxIiByeD0iMS4wMjYiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDkuMTI1IDQxLjQ1NSkiIGZpbGw9IiNlYmYzZmEiLz4KICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV80OTUyNiIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNDk1MjYiIHdpZHRoPSIwLjgyIiBoZWlnaHQ9IjAuMjk3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg5Ljc5IDQxLjE1OCkiIGZpbGw9IiNmZmE1NjEiLz4KICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV80OTUyNyIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNDk1MjciIHdpZHRoPSIyLjA1MSIgaGVpZ2h0PSIwLjkxOSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoOS4xMjUgNDIuNikiIGZpbGw9IiNmZmYiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTQ0OTMiIGRhdGEtbmFtZT0iUGF0aCA5NDQ5MyIgZD0iTTE4ODIuNTg2LDEzMjguODlhOS4xMSw5LjExLDAsMCwwLTEuNzM3LDEuNDIzLDMuMTg5LDMuMTg5LDAsMCwwLS4xNTksMS4zMjdzMS41LjY2OSwxLjMxOS0uMTE3Yy0uMTc1LS43NTQuNDktLjQ2LjkxMi0uODI1YTUuNyw1LjcsMCwwLDAsLjkxMy0xLjQzM1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xODgwLjY4IC0xMjkyLjY1NykiIGZpbGw9IiNmZmIyN2QiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTQ0OTQiIGRhdGEtbmFtZT0iUGF0aCA5NDQ5NCIgZD0iTTE3MTQuMjkzLDg4Ny41M3MtMy43MTQtNC40NjYtNS42ODEtMS42MDhjMCwwLTEuNDY3LjYwOC0yLDMuMTA2LS41NDIsMi41NDcsMS4xNTMsNC40ODQsMi4wMjksNC4wMDUuNTYxLS4zMDYuOTg3LjY3Ni45ODcuNjc2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE2OTcuMzEyIC04ODMuOTc2KSIgZmlsbD0iIzI2MzIzOCIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85NDQ5NSIgZGF0YS1uYW1lPSJQYXRoIDk0NDk1IiBkPSJNMTU3OS4xNTksMTA2MC43MjdjMi45NTMtMS4wODksNS44LTYuMTQxLDUuOC02LjE0MWwtLjkzMS0uNjUyYy0uNzc2LDEuMTM0LTQuMjY1LDMuMzEzLTQuMjY1LDMuMzEzLS4wNzktLjk1My0uMi0xLjgyNi0uMzM4LTIuNjA5LS45NjktNS4zNC0zLjE4NS02LjkyMy0zLjc4LTcuMjU5YTEuMzI1LDEuMzI1LDAsMCwwLS4xNS0uMDc5czAsLjA0LjAwNi4xMTRjLjAwOS4xNTkuMDI4LjQ4NS4wNTkuOTI5QzE1NzUuNzg0LDEwNTEuNjUyLDE1NzYuNjkxLDEwNjEuNjM3LDE1NzkuMTU5LDEwNjAuNzI3WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE1NTcuNTcxIC0xMDMzLjQyMikiIGZpbGw9IiNmZmIyN2QiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTQ0OTYiIGRhdGEtbmFtZT0iUGF0aCA5NDQ5NiIgZD0iTTE3NzcuMiw4NzMuOThzLS41LTItMy40MzQtMS4zNzNjMCwwLDEuNDA1LS4xNzcsMS43OS4zNjRhMi4yOTEsMi4yOTEsMCwwLDAtMS44MTEtLjA3OWMtLjcuNDMtLjgxMSwxLjg2Mi0uNzA3LDIuM3MuODczLDEuNzM3LDEuMzg0LDEuNzM3YTIuMzMzLDIuMzMzLDAsMCwwLDEuMTExLS40NDdaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTc2NS40OTIgLTg3Mi40ODYpIiBmaWxsPSIjMjYzMjM4Ii8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzk0NDk3IiBkYXRhLW5hbWU9IlBhdGggOTQ0OTciIGQ9Ik0xNjc4LjAyNywxMDExLjQ0YzEuNDU5LTMuMjcxLDIuMTU3LTQuMiwyLjE4MS01LjIyNi4wMi0uODE1LS4zODItMS42OTMtMS4xNjEtMy44NDZhOC4wMTEsOC4wMTEsMCwwLDEtLjM4OC0xLjU1N2MtLjYxNy00LjE1MiwxLjc4NS04LjY0LDMuMjc2LTguOTQ2LjQxNS0uMTEsMS4xMi0xLjYwOSwxLjExMS00LjAyNWwuMTg3LjAzNywzLjE0Mi42MjJzLS4wNzEuOTg4LS4wNzMsMS45MmMwLC43NzYuMDQ0LDEuNTA5LjIyLDEuNmwuMzYuMDM0czIuNjIsMy42MzgsMi44NCw3LjAyMi0yLjEsNC44NTQuMDE3LDExLjYxNkMxNjkxLjksMTAxNy42LDE2NzcuMjIxLDEwMTMuMjQ4LDE2NzguMDI3LDEwMTEuNDRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTY3MC43MTEgLTk3OC42ODIpIiBmaWxsPSIjZmZiMjdkIi8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzk0NDk4IiBkYXRhLW5hbWU9IlBhdGggOTQ0OTgiIGQ9Ik0xNzI2LjI2Myw5ODguOTVzLS4wNzEuOTg4LS4wNzMsMS45MmMtMS43NTktLjA1LTIuNjg4LTEuNjU0LTMuMDY5LTIuNTRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTcxMC42IC05NzkuMTM0KSIgZmlsbD0iI2U4OTQ1YiIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85NDQ5OSIgZGF0YS1uYW1lPSJQYXRoIDk0NDk5IiBkPSJNMTY5OS4zNjksOTA5LjE0OWE5LjI1MSw5LjI1MSwwLDAsMS0xLjE0My0yLjdjLS4xNTktLjg4OS4zLTQuMTg0LDMuNjA2LTMuNzA5YTQuNTA5LDQuNTA5LDAsMCwxLDEuODY1LjcwNWMuNzE1LjQ4NiwxLjc1NiwxLjUzNC42LDQuNDA4bC0uMy45NzJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTY4Ny4xNzIgLTkwMC4yOTYpIiBmaWxsPSIjMjYzMjM4Ii8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzk0NTAwIiBkYXRhLW5hbWU9IlBhdGggOTQ1MDAiIGQ9Ik0xNzAyLjQ4MSw5MjUuODExcy00LjE2LjA2OC00LjE2My0yLjUyMy0uNTQzLTQuMzI0LDIuMTE0LTQuNDgzLDMuMTc1LjgzNSwzLjM4NSwxLjdTMTcwMy41NjMsOTI1LjcyNiwxNzAyLjQ4MSw5MjUuODExWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE2ODYuMjMxIC05MTUuMTEyKSIgZmlsbD0iI2ZmYjI3ZCIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85NDUwMSIgZGF0YS1uYW1lPSJQYXRoIDk0NTAxIiBkPSJNMTcyMy4wNTIsOTEyLjEyMXMtMS4xMzgsMy4wNC0yLjg4NSwzLjQ4OWEzLjQ0NSwzLjQ0NSwwLDAsMS0yLjUwNi0uMDE5LDQuOTQ5LDQuOTQ5LDAsMCwwLDEuNjItMi45MjRTMTcyMi4xOTMsOTEwLjY3MywxNzIzLjA1Miw5MTIuMTIxWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE3MDYuOTU1IC05MDguNDg5KSIgZmlsbD0iIzI2MzIzOCIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85NDUwMiIgZGF0YS1uYW1lPSJQYXRoIDk0NTAyIiBkPSJNMTY5NC42NzksOTE1LjU4M2EzLjY3LDMuNjcsMCwwLDEsMS4wNTgsMS4zMzljLjIwNy42NjEuMywyLjAxOC43LDEuOTcyLDAsMCwuODU4LTIuMDY0LS4xMDYtMy4yMzZDMTY5NS4zMDYsOTE0LjQxOSwxNjk0LjY3OSw5MTUuNTgzLDE2OTQuNjc5LDkxNS41ODNaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTY3OC44NjYgLTkxMS43MDUpIiBmaWxsPSIjMjYzMjM4Ii8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzk0NTAzIiBkYXRhLW5hbWU9IlBhdGggOTQ1MDMiIGQ9Ik0xNjc2LjU3LDEzMjYuNTU3YTQxLjA4Nyw0MS4wODcsMCwwLDAsMi42Miw3LjM1NmwxLjM3Mi0uMWEzOC44NzQsMzguODc0LDAsMCwxLS42MzUtNy41MjUsMzEuNDA5LDMxLjQwOSwwLDAsMSwxLjYtMTAuMDA4YzQuMTA1LTExLjcyMywzLjQ0MS0yMC4yNTUsMy40NDEtMjAuMjU1bC03LjcxOS45LS4zNi4wNDJjLS4wMzMsMy41NDYtLjEyNCw4LjM1OS0uMiwxMi4xMjMtLjA3MSwzLjM4NS0uMTMyLDUuOTIxLS4xMzIsNS45MjFDMTY3NS4wNjcsMTMxOC4yMTQsMTY3NS42MDcsMTMyMi43MjYsMTY3Ni41NywxMzI2LjU1N1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNjY1LjU3IC0xMjYyLjQwNikiIGZpbGw9IiMwNzEzMWEiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTQ1MDQiIGRhdGEtbmFtZT0iUGF0aCA5NDUwNCIgZD0iTTE3NzYuMzksMTA2MC42ODhsMS4yNDkuMzc1czQuMTItNi44MzYsNC40OTQtOC42MTVjLjEyMi0uNTguNDIyLTEuNzM4Ljc3Mi0zLjAzNi43MjMtMi42ODksMS42NTctNS45NzksMS42NTctNS45NzlsLjMwOC0xLjMzMiwxLjA0OS00LjU0MmExNC4yNjUsMTQuMjY1LDAsMCwwLTMuMTgzLjcsMS40NjMsMS40NjMsMCwwLDAtLjc4OS41ODNjLS44NjMsMS45LTEuNzI0LDYuNjg2LTIuMzMsMTAuMS0uMzM3LDEuOTA1LS41OTUsMy4zODEtLjcyOSwzLjY5NUMxNzc4LjUxMywxMDUzLjUwOSwxNzc3LjM2OCwxMDU4LjMxNSwxNzc2LjM5LDEwNjAuNjg4WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE3NzQuNDg0IC0xMDI0LjQ1NSkiIGZpbGw9IiNmZmIyN2QiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTQ1MDUiIGRhdGEtbmFtZT0iUGF0aCA5NDUwNSIgZD0iTTE3MjMuMTExLDEzMDcuMDg0YTE5LDE5LDAsMCwwLDIuNCw3LjhsLjY1Ni40NzZzLjYyLTMuMzM0LDEuMDU5LTcuM2MuNDE4LTMuNzczLjk5MS03Ljc2NywxLjY0LTguOTg2LDIuNTc0LTQuODM0LDMuMzQ5LTIzLjA4MywzLjM0OS0yMy4wODNsLTcuODI2LS4zODhhMTMuMzkzLDEzLjM5MywwLDAsMC0xLjIxMSw1Ljk2MSw4NC44NzUsODQuODc1LDAsMCwwLDEuNDc3LDE1LjUyNGgwYS40MDguNDA4LDAsMCwxLS4wNTIuMjYzQTE3Ljk2MSwxNy45NjEsMCwwLDAsMTcyMy4xMTEsMTMwNy4wODRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTcxNi41MzkgLTEyNDMuNTk4KSIgZmlsbD0iIzI2MzIzOCIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85NDUwNiIgZGF0YS1uYW1lPSJQYXRoIDk0NTA2IiBkPSJNMTcyMi4yNDcsOTEzLjAyNnMtLjgxMSwzLjE4My0zLjAxNyw0LjJjMCwwLDIuMjA1LTEuOTU1LDIuMzkzLTQuMDU4UzE3MjIuMjQ3LDkxMy4wMjYsMTcyMi4yNDcsOTEzLjAyNloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNzA2LjI3NSAtOTA5LjA0NSkiIGZpbGw9IiMyNjMyMzgiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTQ1MDciIGRhdGEtbmFtZT0iUGF0aCA5NDUwNyIgZD0iTTE1NTguNDc1LDEwOTIuNTIyYzAtLjEyOS0uMTA3LTEuOTg1LjIyMy0yLjM3N3MxLjAwNi0uOTQ1LDEuMjE4LS45MjlhMi4wOTIsMi4wOTIsMCwwLDEsLjc5NCwxLjk2Nyw2LjkxOSw2LjkxOSwwLDAsMS0xLjMsMS45OVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNTMyLjAyMiAtMTA3Mi4wMSkiIGZpbGw9IiNmZmIyN2QiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTQ1MDgiIGRhdGEtbmFtZT0iUGF0aCA5NDUwOCIgZD0iTTE3ODUuODQsMTY3Mi4xOWExOSwxOSwwLDAsMCwyLjQsNy44bC42NjguNjA3cy42MDgtMy40NjgsMS4wNDctNy40MzlBNy4wMTQsNy4wMTQsMCwwLDEsMTc4NS44NCwxNjcyLjE5WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE3NzkuMjY5IC0xNjA4LjcwMykiIGZpbGw9IiNmZmIyN2QiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTQ1MDkiIGRhdGEtbmFtZT0iUGF0aCA5NDUwOSIgZD0iTTE3MzEuNTgsMTY3Ny40OTRhNDEuMDg1LDQxLjA4NSwwLDAsMCwyLjYyLDcuMzU2bDEuMzcyLS4xYTM4Ljg2OSwzOC44NjksMCwwLDEtLjYzNS03LjUyNUE2LjIxLDYuMjEsMCwwLDEsMTczMS41OCwxNjc3LjQ5NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNzIwLjU4MSAtMTYxMy4zNDQpIiBmaWxsPSIjZmZiMjdkIi8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzk0NTEwIiBkYXRhLW5hbWU9IlBhdGggOTQ1MTAiIGQ9Ik0xNjgxLjg4MiwxNzUwLjkyMmguODczYy4yOTQtLjA0Ny41MS0uMTMyLjgxLS4xNzFhLjgxLjgxLDAsMCwxLC43MS4xNzFsLjAwOC4wMDlIMTY4OGMuMDk0LS4xMzQsMC0uNDQ0LS4wODQtLjY3MWEuNTMuNTMsMCwwLDAtLjM0OC0uMzE4LDQsNCwwLDAsMS0xLjg4NS0uODYxYy0uNC0uMzYyLTEuOTM2LTEuMzMxLTEuOTM2LTEuMzMxaC0uMDA4Yy0uMDM0LDAtLjE5NC4wNS0uODkyLjY0LS4zNi4zLS45NzYtLjQzLS45NzYtLjQzYS44NzguODc4LDAsMCwwLS4yLjI3My45MjQuOTI0LDAsMCwwLS4wNzkuNTcyLDMuNywzLjcsMCwwLDEtLjI2NywxLjM3OWMtLjA4Ny4yNTUtLjE1OS40MzctLjE1OS40MzdTMTY4MS4xMjksMTc1MC44MjgsMTY4MS44ODIsMTc1MC45MjJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTY2OS4wNTEgLTE2NzguMjY1KSIgZmlsbD0iIzA3MTMxYSIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85NDUxMSIgZGF0YS1uYW1lPSJQYXRoIDk0NTExIiBkPSJNMTczNS4yLDE3NDguMjc2YTIuOCwyLjgsMCwwLDAsLjk0My40NzZjLjQuMDUyLDEuMTM1LS45NTMsMS4xMzUtLjk1M2gtLjAwOGMtLjAzNCwwLS4xOTQuMDUtLjg5Mi42NC0uMzYuMy0uOTc2LS40MjktLjk3Ni0uNDI5YS44NzkuODc5LDAsMCwwLS4yLjI2NloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNzIyLjU3NCAtMTY3OC4zMTEpIiBmaWxsPSIjNDY2YWE1Ii8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzk0NTEyIiBkYXRhLW5hbWU9IlBhdGggOTQ1MTIiIGQ9Ik0xNjgxLjg4MiwxNzc5LjExMmguODczYy4yOTQtLjA0Ny41MS0uMTMyLjgxLS4xNzFhLjgwOS44MDksMCwwLDEsLjcxLjE3MWwuMDA4LjAwOUgxNjg4Yy4wOTQtLjEzNCwwLS40NDQtLjA4NC0uNjcyLS4xMTMtLjEtLjE0NS40MzctLjIwNy41MjJhMTYuNTgzLDE2LjU4MywwLDAsMS0zLjIwNy0uMDk0LDEuOCwxLjgsMCwwLDAtMS40LS4xNzIsMy4zODYsMy4zODYsMCwwLDEtMS43NzQtLjMzNWMtLjA4Ny4yNTYtLjE1OS40MzctLjE1OS40MzdTMTY4MS4xMjksMTc3OS4wMTcsMTY4MS44ODIsMTc3OS4xMTJaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTY2OS4wNTEgLTE3MDYuNDU0KSIgZmlsbD0iIzQ2NmFhNSIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85NDUxMyIgZGF0YS1uYW1lPSJQYXRoIDk0NTEzIiBkPSJNMTc0MC43NjEsMTc1MC45MjJoLjg3M2MuMjk0LS4wNDcuNTEtLjEzMi44MTEtLjE3MWEuODEuODEsMCwwLDEsLjcxLjE3MWwuMDA4LjAwOWgzLjcyYy4wOTQtLjEzNCwwLS40NDQtLjA4NC0uNjcxYS41MzEuNTMxLDAsMCwwLS4zNDktLjMxOCw0LjAwNiw0LjAwNiwwLDAsMS0xLjg4NS0uODYxYy0uNC0uMzYyLTEuOTM1LTEuMzMxLTEuOTM1LTEuMzMxaC0uMDA4Yy0uMDM0LDAtLjE5NC4wNS0uODkyLjY0LS4zNjEuMy0uOTc2LS40My0uOTc2LS40M2EuODc4Ljg3OCwwLDAsMC0uMi4yNzMuOTI5LjkyOSwwLDAsMC0uMDc5LjU3MiwzLjcsMy43LDAsMCwxLS4yNjYsMS4zNzljLS4wODcuMjU1LS4xNTkuNDM3LS4xNTkuNDM3UzE3NDAuMDA3LDE3NTAuODI4LDE3NDAuNzYxLDE3NTAuOTIyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE3MzIuNjAzIC0xNjc4LjI2NSkiIGZpbGw9IiMwNzEzMWEiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTQ1MTQiIGRhdGEtbmFtZT0iUGF0aCA5NDUxNCIgZD0iTTE3OTQuMDcsMTc0OC4yNzZhMi43OCwyLjc4LDAsMCwwLC45NDMuNDc2Yy40LjA1MiwxLjEzNC0uOTUzLDEuMTM0LS45NTNoLS4wMDhjLS4wMzQsMC0uMTk0LjA1LS44OTIuNjQtLjM2MS4zLS45NzYtLjQyOS0uOTc2LS40MjlBLjg3OC44NzgsMCwwLDAsMTc5NC4wNywxNzQ4LjI3NloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNzg2LjExNyAtMTY3OC4zMTEpIiBmaWxsPSIjNDY2YWE1Ii8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzk0NTE1IiBkYXRhLW5hbWU9IlBhdGggOTQ1MTUiIGQ9Ik0xNzQwLjc2MiwxNzc5LjExMmguODczYy4yOTQtLjA0Ny41MS0uMTMyLjgxMS0uMTcxYS44MDguODA4LDAsMCwxLC43MS4xNzFsLjAwOC4wMDloMy43MmMuMDk0LS4xMzQsMC0uNDQ0LS4wODQtLjY3Mi0uMTEzLS4xLS4xNDQuNDM3LS4yMDcuNTIyYTE2LjU4NCwxNi41ODQsMCwwLDEtMy4yMDctLjA5NCwxLjgsMS44LDAsMCwwLTEuNC0uMTcyLDMuMzg1LDMuMzg1LDAsMCwxLTEuNzc0LS4zMzVjLS4wODcuMjU2LS4xNTkuNDM3LS4xNTkuNDM3UzE3NDAuMDA5LDE3NzkuMDE3LDE3NDAuNzYyLDE3NzkuMTEyWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE3MzIuNjA0IC0xNzA2LjQ1NCkiIGZpbGw9IiM0NjZhYTUiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTQ1MTYiIGRhdGEtbmFtZT0iUGF0aCA5NDUxNiIgZD0iTTE2MzguMzksMTA0NC42MzZjMS41NTMtMi43MywxLjYyNy0zLjgyNiwzLjE1Mi00Ljc3MWE5LjU0Niw5LjU0NiwwLDAsMSwyLjk3NS0uODY1LDEyLjkyLDEyLjkyLDAsMCwwLC45NjgsMi45NzJjLjM3NS4zNDMsNS44MDYuOTA1LDUuOTMuMjgxLjEyLS42LTEuNDExLTIuOTE1LTEuNTI3LTMuMTE5YTIuMjg2LDIuMjg2LDAsMCwxLC4yNDcuMDE5Yy42MTkuMDc5LDEuMDU2LjE0NCwxLjM3Mi4yYTMuMDA1LDMuMDA1LDAsMCwxLC43Ni4yYy4zNy4wNiwyLjE4Mi42MTksNC4wODgsNS43OSwwLDAtMS41NDgsMS45NDItMi43NDUsMi4yODZsLS4xLjAyNWMuMjA4LDMuNDczLDEuNDg2LDkuMjUsMS4wMjYsMTIuNTk0LS40NDIsMy4yMTQtNy4yLDIuMzkyLTguNTQ0LDIuMDk0cS0xLjM3OC0uMzA2LTIuMTM2LTIuOWMtLjE2OCwxLjIwOC0uNTQ1LDIuNjI1LTEuMzksMi43MTItMS4zODIuMTQ0LTEuOTU1LS4xLTIuMTItLjYxOWExLjg0NSwxLjg0NSwwLDAsMS0uMDQ5LS42MjUsOTMuMTc3LDkzLjE3NywwLDAsMSwxLjc3NC05LjI4OGMuMzU1LTEuNTU3Ljg0OS0yLjcxMiwxLjAzMi0zLjg5QTUuNzg5LDUuNzg5LDAsMCwxLDE2MzguMzksMTA0NC42MzZaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTYzMy45NjYgLTEwMjUuNzgxKSIgZmlsbD0iIzQ1NWE2NCIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85NDUxNyIgZGF0YS1uYW1lPSJQYXRoIDk0NTE3IiBkPSJNMTU1OS42LDEwNzIuNTYyYy0uMDM5LS4xNTEtLjIzOC0zLjEtLjMxOC0yLjgxN3MtLjI4MiwxLjgyNi0uMjgyLDEuODI2WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE1MzAuOTA4IC0xMDU0LjA2OCkiIGZpbGw9IiNmZmIyN2QiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTQ1MTgiIGRhdGEtbmFtZT0iUGF0aCA5NDUxOCIgZD0iTTE1NTIuOTc5LDEwNTEuODZsLS4xMTYuMy0xLjc4Myw0LjYzNi44NjEuMzgsMi4zNjctNC4zNzkuMTU0LS4yODRaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTUyNS4xNDIgLTEwMzcuNjIpIiBmaWxsPSIjMjI1Mzk5Ii8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzk0NTE5IiBkYXRhLW5hbWU9IlBhdGggOTQ1MTkiIGQ9Ik0xNTUxLjIsMTA1MS44NmwtLjExNi4zLDEuNDQ2LjYzNy4xNTQtLjI4NFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNTIzLjM1OSAtMTAzNy42MikiIGZpbGw9IiMxNzQ4ODQiLz4KICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZV80OTU4MSIgZGF0YS1uYW1lPSJSZWN0YW5nbGUgNDk1ODEiIHdpZHRoPSIwLjk5NSIgaGVpZ2h0PSIwLjgxNiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMjYuNjg0IDE5LjkyNSkgcm90YXRlKC0xNTYuMjMpIiBmaWxsPSIjZmZmIi8+CiAgICAgIDxwYXRoIGlkPSJQYXRoXzk0NTIwIiBkYXRhLW5hbWU9IlBhdGggOTQ1MjAiIGQ9Ik0xNTY3Ljg2OCwxMDc3LjQ1NHMtLjgtMS4yMzQtMS0xLjE2NWMtLjI4LjEuNzI3LDEuNjY3LjcyNywxLjY2N3MtLjc0Ni0xLjE3LS44NjMtMS4wODJjLS4yNjUuMi4xNTkuOTM2LjU3NiwxLjUsMCwwLS43NS0uNjg3LS43NzUtLjU2My0uMDg2LjQzNC44MjQsMS40ODQuODI0LDEuNDg0bC41MDgtMS4xNjFaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTUzOS43NzMgLTEwNjAuMTA2KSIgZmlsbD0iI2ZmYjI3ZCIvPgogICAgICA8cGF0aCBpZD0iUGF0aF85NDUyMSIgZGF0YS1uYW1lPSJQYXRoIDk0NTIxIiBkPSJNMTcwNy43MjYsOTg1LjYwNnMuMDcyLjMwNi44MzIuMjU4YzAsMCwuNjM1LS4wMzkuNjE5LS4zNzVBMi4wNDgsMi4wNDgsMCwwLDAsMTcwNy43MjYsOTg1LjYwNloiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNjkyLjI5MiAtOTc2LjQ0NikiIGZpbGw9IiNmZmYiLz4KICAgICAgPHBhdGggaWQ9IlBhdGhfOTQ1MjUiIGRhdGEtbmFtZT0iUGF0aCA5NDUyNSIgZD0iTTE4ODQuMjQ0LDEzMzcuNzdhNS4wNDcsNS4wNDcsMCwwLDEtLjU1NiwxLjUyNWMtLjMuMzQ1LS43MjkuOTIxLS45Ljc2OHMuMTkyLTEuNDM5LjE5Mi0xLjQzOVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xODgxLjI1MyAtMTMwMC44MzIpIiBmaWxsPSIjZmZiMjdkIi8+CiAgICA8L2c+CiAgICA8cGF0aCBpZD0iUGF0aF85NDUyNiIgZGF0YS1uYW1lPSJQYXRoIDk0NTI2IiBkPSJNMTgyLjE0NCwxNzg2Ljk5MUg2Ny4xNWMtLjA3MiwwLS4xMy4xMjItLjEzLjI3M3YuMDk0YzAsLjE1MS4wNTguMjczLjEzLjI3M0gxODIuMTQ0Yy4wNzIsMCwuMTMtLjEyMi4xMy0uMjczdi0uMDk0YzAtLjE1MS0uMDU5LS4yNzQtLjEzMS0uMjc0WiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTY3LjAyIC0xNzA5Ljk5MikiIGZpbGw9IiMyZTM1NTIiLz4KICA8L2c+Cjwvc3ZnPgo=",
      status: true,
      version: "1",
      active: true,
      createdby: "",
      createddate: 1647926614,
      updatedby: "",
      updatedate: 1651080187,
      activestatus: true,
    },
  ],
  statesid: ["Verification"],
  status: null,
  status_id: "",
  statushistory: [
    {
      PersonID: "",
      old_status: "",
      fromperiod: 0,
      new_status: "",
      status_reason: "",
      toperiod: 0,
    },
  ],
  ticketId: "T122",
  addtictive: [],
  Recievednextrefilldate: 1649587663,
};

const brand = {
  name: null,
  strength: "undefined undefined",
  route: "Oral",
  doseCount: 0,
  tabPerDose: 0,
  actualdoseCount: 0,
  batches: [],
  option: [
    {
      drugName: null,
      drugNameShort: null,
      packSizeApplicability: [],
      seqno: 0,
      drugNameLong: null,
    },
  ],
  drugName: null,
  drugNameShort: null,
  packSizeApplicability: [],
  seqno: 0,
  drugNameLong: null,
};
